/* eslint-disable curly */
import React, { Component } from "react";
import {
  StyleSheet,
  View,
  Text,
  Dimensions,
  TextInput,
  Platform,
  TouchableOpacity,
  ImageBackground,
  KeyboardAvoidingView,
  StatusBar,
} from "react-native";
import { StackActions, NavigationActions } from "react-navigation";
import Icon from "react-native-vector-icons/FontAwesome";

import { autentica as autenticaAluno } from "../../services/aluno-service";
import { onSignIn } from "../../services/auth-service";
import styles from "./styles";
import ButtonConfirm from "../../components/ButtonConfirm";
import Loading from "../../components/Loading";
import { alert } from "../../utils/alerts";

class ValidarSenha extends Component {
  constructor(props) {
    super();
    this.state = {
      senha: "",
      confirmDisabled: true,
      loading: false,
    };

    // StatusBar.setBackgroundColor("#F000");
  }

  validado = () => {
    const { senha } = this.state;
    if (!senha) {
      alert("Ops...", "Preencha a senha");
      return false;
    }
    return true;
  };

  validarSenha = async () => {
    if (!this.validado()) return;

    this.setState({ ...this.state, loading: true });

    const { senha } = this.state;
    let aluno = this.props.navigation.getParam("aluno");

    const alunoAutenticar = {};
    alunoAutenticar.cpf = aluno.cpf;
    alunoAutenticar.senha = senha;

    try {
      const response = await autenticaAluno(alunoAutenticar);

      if (!response.ok) {
        const erro = await response.json();

        this.setState({ ...this.state, loading: false });

        return alert("Ops...", erro.erro);
      }
      const alunoSessao = await response.json();

      onSignIn(alunoSessao);

      this.setState({ ...this.state, loading: false });

      const navigateAction = StackActions.reset({
        index: 0,
        actions: [NavigationActions.navigate({ routeName: "SignedIn" })],
      });

      this.props.navigation.dispatch(navigateAction);
    } catch (erro) {
      this.setState({ ...this.state, loading: false });

      console.log(erro);
    }
  };

  handlerPass = (e) => {
    this.setState({ senha: e, confirmDisabled: e.length > 0 ? false : true });
  };

  render() {
    const { navigation } = this.props;
    const aluno = this.props.navigation.getParam("aluno");

    return (
      <>
        {this.state.loading && <Loading />}
        <KeyboardAvoidingView
          style={styles.container}
          behavior={Platform.OS === "ios" ? "padding" : "null"}
          enabled
        >
          <ImageBackground
            source={require("../../../resources/imgs/bg.jpg")}
            style={styles.container}
            imageStyle={styles.imageContainer}
          >
            <View style={styles.containerForm}>
              <TouchableOpacity
                style={styles.iconClose}
                onPress={() => {
                  // StatusBar.setBackgroundColor("#F00");
                  navigation.pop(1);
                }}
              >
                <Icon name={"close"} size={30} color="#FFF" />
              </TouchableOpacity>
              <Text style={styles.textHeader1}>
                Olá, vi aqui que você já cadastrou uma senha
              </Text>
              <Text style={styles.textHeader2}>
                Insira sua senha para entrar:
              </Text>
              <TextInput
                style={styles.input}
                placeholder="********"
                placeholderTextColor="#ccc"
                secureTextEntry={true}
                autoFocus={true}
                onChangeText={this.handlerPass}
              />
              <TouchableOpacity
                onPress={() => {
                  let aluno = this.props.navigation.getParam("aluno");
                  navigation.navigate("ResetSenhaCpf", { aluno });
                }}
              >
                <Text style={styles.link}>Esqueceu a senha?</Text>
              </TouchableOpacity>
              <ButtonConfirm
                text="Continuar"
                disabled={this.state.confirmDisabled}
                onPress={this.validarSenha}
                msgDisabled="Ops, você deve colocar uma senha."
              />
            </View>
          </ImageBackground>
        </KeyboardAvoidingView>
      </>
    );
  }
}

export default ValidarSenha;
